// @ts-nocheck
class WIgridview extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.clickGrid();
    }

    disconnectedCallback() {

    }

    // click on view number button
    clickGrid() {
        this.addEventListener('click',(e)=>{
            if (e.target?.tagName.toLowerCase() === 'button') {
                 document.querySelectorAll('.GridViewBtn').forEach(btn => {
                });
                let targetData = e.target.getAttribute('data-num');
                let proGrid = document.querySelector('.WI_mainCollection_main #WI_mainCollection_grpGrid');
                proGrid.style.gridTemplateColumns = `repeat(${targetData}, 1fr)`;
            }
        });
    }
}

customElements.define('wi-gridview', WIgridview);